import Icon from 'veui/components/Icon'
import { IconThumbUpSolid } from 'dls-icons-vue'

Icon.register('thumb-up-solid', IconThumbUpSolid)
